import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { usePostMessage } from 'spectacle-ui-game-bridge-react';
import { useState, useCallback } from 'react';
import { getPath } from '../../config';
import Build from '../../components/build/build';
import LoadingIndicator from '../../components/loadingIndicator/loadingIndicator';
import useContentForBuild from '../../hooks/useContentForBuild';

export default function CodeOfConduct() {
  const navigate = useNavigate();
  const openUrl = usePostMessage('openUrl');
  const acceptCodeOfConduct = usePostMessage('acceptCodeOfConduct');
  const passPreloginFence = usePostMessage('passPreloginFence');
  const [content, loading] = useContentForBuild();

  const [acceptance, setAcceptance] = useState({
    codeOfConductAcceptance: false,
  });

  const isButtonDisabled = !acceptance.codeOfConductAcceptance;

  const handleChange = (e: any) => {
    const value = e.target.checked;
    const name = e.target.name;

    setAcceptance((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUrl = useCallback(
    (e: any) => {
      e.preventDefault();
      const href = e.target.href;

      openUrl(href);
    },
    [openUrl]
  );

  const accept = (e: any) => {
    e.preventDefault();
    acceptCodeOfConduct(content?.codeOfConductAgreementVersion);

    if (content?.webBasedLogin) {
      navigate('/login');
    } else {
      passPreloginFence();
    }
  };

  return (
    <>
      <Helmet>
        <title>{content?.reviewTerms}</title>
      </Helmet>
      {loading && (
        <div className="loading-mask">
          <LoadingIndicator />
        </div>
      )}
      {content && (
        <div className="centered">
          <div className="frame frame--extra-padding">
            <div className="frame__corner-tl" />
            <div className="frame__corner-tr" />
            <div className="frame__corner-bl" />
            <div className="frame__corner-br" />
            <div className="logo-inline">
              <img src={getPath('menu_cod_logo_lg')} alt="Call of Duty" />
              <h1>{content.reviewTerms}</h1>
            </div>
            <div className="checkbox">
              <input type="checkbox" id="codeOfConductAcceptance" name="codeOfConductAcceptance" checked={acceptance.codeOfConductAcceptance} onChange={handleChange} />
              <div>
                <label htmlFor="codeOfConductAcceptance">
                  <div>{content.codeOfConductAcceptance}</div>
                  <a onClick={handleUrl} href={content.codeOfConductAgreementUrl}>
                    {content.codeOfConductCta} <img src={getPath('icon_link')} alt={content.codeOfConductCta} />
                  </a>
                </label>
              </div>
            </div>
            <button disabled={isButtonDisabled} className="cta cta--full" onClick={accept}>
              {content.agree}
            </button>
          </div>
        </div>
      )}
      <div className="build">
        <Build />
      </div>
    </>
  );
}
